import { Link } from 'react-router-dom';
import styled from 'styled-components';

const LogoWrapper = styled.div`
  display: flex;
  flex: 1;
  flex-direction: row;
  font-size: 6vmin;
  line-height: 1;
  text-shadow: 0 1vmin #000;
`;
const LogoLink = styled(Link)`
  display: flex;
  flex-direction: column;
  text-decoration: none;
`;
const Bs = styled.div`
  display: flex;
  font-size: 5vmin;
  margin-left: 3.3vmin;
  letter-spacing: -0.2vmin;
  color: ${(props) => props.theme.color.white};
  -webkit-text-stroke: 0.2vmin #000;
`;
const Drafting = styled.div`
  display: flex;
  justify-content: center;
  font-size: 6vmin;
  color: ${(props) => props.theme.color.red};
  margin-top: -2.6vmin;
`;
const D = styled.div`
  -webkit-text-stroke: 0.4vmin #000;
`;
const R = styled.div`
  margin-left: -0.2vmin;
  -webkit-text-stroke: 0.4vmin #000;
`;
const A = styled.div`
  margin-left: -0.6vmin;
  -webkit-text-stroke: 0.4vmin #000;
`;
const F = styled.div`
  margin-left: -0.5vmin;
  -webkit-text-stroke: 0.4vmin #000;
`;
const T = styled.div`
  margin-left: -0.5vmin;
  -webkit-text-stroke: 0.4vmin #000;
`;
const I = styled.div`
  margin-left: -0.3vmin;
  -webkit-text-stroke: 0.4vmin #000;
`;
const N = styled.div`
  margin-left: -0.4vmin;
  -webkit-text-stroke: 0.4vmin #000;
`;

const G = styled.div`
  margin-left: -0.4vmin;
  -webkit-text-stroke: 0.4vmin #000;
`;

const Star = styled.img`
  width: 12vmin;
  margin: -4vmin auto -12vmin auto;
`;

export const Logo = () => {
  return (
    <LogoWrapper>
      <LogoLink to="/">
        <Bs>BS</Bs>
        <Drafting>
          <D>D</D>
          <R>r</R>
          <A>a</A>
          <F>f</F>
          <T>t</T>
          <I>i</I>
          <N>n</N>
          <G>G</G>
        </Drafting>
        <Star src={`${process.env.PUBLIC_URL}/images/star.webp`} alt="" />
      </LogoLink>
    </LogoWrapper>
  );
};
